import _parsePhoneNumber, {
  findPhoneNumbersInText as _findPhoneNumbersInText,
  AsYouType as _AsYouType,
} from 'libphonenumber-js';

type CountryCode = 'US';

export function parsePhoneNumber(text: string, defaultCountry: CountryCode = 'US') {
  return _parsePhoneNumber(text, defaultCountry);
}

export function findPhoneNumbersInText(text: string, defaultCountry: CountryCode = 'US') {
  return _findPhoneNumbersInText(text, defaultCountry);
}

export function AsYouType(defaultCountry: CountryCode = 'US') {
  return new _AsYouType(defaultCountry);
}

export function isValidPhoneNumber(text: string, defaultCountry: CountryCode = 'US') {
  const phoneNumber = parsePhoneNumber(text, defaultCountry);
  return phoneNumber?.isValid() ?? false;
}

export const AsYouTypeUS = () => AsYouType('US');

export function safeFormatToNational(phoneNumber: string): string {
  const isValid = isValidPhoneNumber(phoneNumber);
  const parsedNumber = parsePhoneNumber(phoneNumber);
  if (!isValid || !parsedNumber) {
    return phoneNumber;
  }
  return parsedNumber.formatNational();
}

export function formatToDashedNational(phoneNumber: string): string {
  const parsedNumber = parsePhoneNumber(phoneNumber);
  if (!parsedNumber?.isValid()) {
    return phoneNumber;
  }
  return parsedNumber.nationalNumber.toString().replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
}
